module.exports = __webpack_public_path__ + "img/Blumenwiese-1216@2x.3ce54079.jpg";